import { enumUISubModes } from "../constants";
import { Globals } from "../CoreApp/Globals";

export function isInBackgroundEditor() {
  return Globals._uiConfig.InBackgroundEditorMode();
}
